import Tags from './Tags'
import enhance from './Tags.enhancer'

export default enhance(Tags)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Tags/components/Tags/index.js